<template>
    <a-spin :tip="$t('Loading...')" :spinning="getting_data">
        <navbar active_screen="delight" />
        <v-infinite-scroll :loading="getting_data" @bottom="nextPage" style="overflow-y: scroll; overflow-x: hidden">
            <div class="ml-12 mr-12 mb-12">
                <!-- <div class="row" style="background: linear-gradient(180deg, #4b4b4b, #000 100%) no-repeat; width: auto; height: 40px; line-height: 40px; margin: 0 64px">
                <span class="col-6 fs-16 color-white" style="text-align: right"> ร่วมอนุรักษ์ทรัพยากร ลดการใช้กระดาษ</span>
                <div class="col-6">
                    <div class="primary-btn" style="height: 12px; line-height: 12px; padding: 8px; display: table; position: relative; top: 50%; -webkit-transform: translateY(-50%); -ms-transform: translateY(-50%); transform: translateY(-50%)">
                        <span class="fs-16 color-white" style="display: table-cell; vertical-align: middle"> ยกเลิกฉบับพิมพ์</span>
                    </div>
                </div>
            </div> -->
                <template v-for="(row, row_index) in delights">
                    <div :key="'row_index_' + row_index" class="text-center">
                        <template v-for="(col, col_index) in row">
                            <div
                                class="br-12"
                                :key="'col_index_' + col_index"
                                style="margin: 4px; display: inline-block; width: 46%"
                                @click="
                                    $router.replace({
                                        path: '/delight-detail',
                                        query: { delight_id: col.id },
                                    })
                                "
                            >
                                <img
                                    :src="col.image"
                                    class="br-12"
                                    :style="{
                                        width: $device == 'mobile' ? '100%' : '50%',
                                        margin: '0 auto',
                                    }"
                                />
                                <div class="mt-20">
                                    <span class="title fs-20 red">
                                        {{ col.title }}
                                    </span>
                                </div>
                                <div class="mb-20">
                                    <span class="title sub fs-20">
                                        {{ col.excerpt }}
                                    </span>
                                </div>
                            </div>
                        </template>
                    </div>
                </template>
            </div>
            <div class="กำลังโหลดข้อมูลเพิ่ม" v-if="getting_data">กำลังโหลดข้อมูลเพิ่ม</div>
            <div v-if="$device != 'mobile'" class="copyright-section-space"></div>
            <div v-if="$device != 'mobile'" class="copyright-section">© Copyright SCG Debenture Club. All Rights Reserved.</div>
        </v-infinite-scroll>
        <div class="text-center custom-cancel-print" style="padding-bottom: 8px">
            <a-button size="large" class="text-center bg-red br-20" v-if="user.magazine == 1" @click="cancelPrint">
                <span class="fs-18 color-white">ยกเลิกฉบับพิมพ์</span>
                <!-- <span class="fs-18 color-white" v-else>รับฉบับพิมพ์</span> -->
            </a-button>
        </div>
        <modal-form ref="modalForm" :visible="modal_visible" :data="modal_data" v-if="modal_visible" @on-cancel="onModalCancel" />
    </a-spin>
</template>
<script>
import navbar from '../../components/navbar';
import modalForm from './modalForm';
export default {
    components: {
        navbar,
        modalForm,
    },
    data: function () {
        return {
            delights: [],
            getting_data: true,
            current_page: 1,
            last_page: 0,
            modal_visible: false,
            modal_data: {},
            user: this.$store.state.user,
        };
    },
    mounted() {
        this.getDelight(() => (this.getting_data = false));
    },
    methods: {
        nextPage() {
            if (this.current_page < this.last_page) {
                ++this.current_page;
                this.getDelight();
            }
        },
        getDelight: function (callback = null, current_page = null) {
            if (typeof current_page != 'number') current_page = this.current_page;
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/delight/index',
                    data: {
                        page: current_page,
                    },
                    callback: (res) => {
                        if (res) {
                            this.last_page = res.last_page;
                            this.atg(res.data, 2).forEach((v) => {
                                this.delights.push(v);
                            });
                            if (typeof callback == 'function') callback();
                        } else if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        onModalCancel() {
            this.modal_visible = false;
            this.modal_data = {};
            location.reload();
        },
        cancelPrint() {
            this.loading = true;
            this.modal_visible = false;
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/changeProfile',
                    data: {
                        magazine: this.user.magazine == 0 ? 1 : 0,
                    },
                    callback: (res) => {
                        console.log('res.complete', res);
                        const complete = {};
                        if (res && res.result == 'complete') {
                            this.modal_data.message = res.result;
                            for (const [key, value] of Object.entries(res.complete)) {
                                if (key) {
                                    complete.description = value[0];
                                }
                            }
                        } else {
                            for (const [key, value] of Object.entries(res.errors)) {
                                if (key && value[0]) {
                                    complete.description = value[0];
                                }
                            }
                        }
                        this.modal_data.title = 'ยกเลิกฉบับพิมพ์สำเร็จ';
                        this.modal_data.message = 'ท่านได้ยกเลิกการรับนิตสารฉบับพิมพ์';
                        this.modal_data.message2 = 'เรียบร้อยแล้ว';
                        this.loading = false;
                        this.modal_visible = true;
                    },
                },
            });
        },
    },
};
</script>
<style scoped>
.title {
    font-weight: 600;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.title.sub {
    font-weight: 300;
}
.custom-cancel-print {
    position: sticky;
    bottom: calc(100vh * 0.1489);
}
</style>